import { Navigate } from 'react-router-dom'
import { useParams } from '@/router/hooks'
import NovelExport from './NovelExport'

/**
 * 标题/作者已改到侧栏直接编辑；设置页只保留导出（账号弹窗也可一键导出）。
 * basic → 回正文，避免空页。
 */
const NovelSettings = () => {
  const { tabId } = useParams()
  if (tabId !== 'export') {
    return <Navigate to="../manuscript" replace />
  }
  return (
    <div className="h-full overflow-auto">
      <NovelExport />
    </div>
  )
}

export default NovelSettings
